import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { reloadWorkspaces, useWorkspace } from 'hooks/useWorkspace';

import { setUserProfile } from 'Redux/Actions/userActions';

import { syncWebDashboard } from 'services/workspaceService';

import { PLUGIN_SOURCE } from 'utlis/constants';

const TeamDashboard = () => {
  const dispatch = useDispatch();
  const authUser = useSelector(state => state.userStore);
  const userProfile = authUser;
  const { workspaces, isLoadingWorkspaces } = useWorkspace();
  const syncCalledRef = useRef(false);

  // Ensure user profile (including plugin_source) is loaded
  useEffect(() => {
    if (authUser?.uuid && !Array.isArray(userProfile?.plugin_source)) {
      dispatch(setUserProfile(authUser));
    }
  }, [authUser?.uuid, dispatch]);

  // Call sync API if WEB_DASHBOARD source is missing OR no default workspace exists
  useEffect(() => {
    if (syncCalledRef.current || !authUser?.uuid || isLoadingWorkspaces) {
      return;
    }

    if (!Array.isArray(userProfile?.plugin_source)) {
      return;
    }

    const hasWebDashboard = userProfile.plugin_source.includes(PLUGIN_SOURCE.webDashboard);
    const hasDefaultWorkspace = Array.isArray(workspaces) && workspaces.some(w => w.is_default);

    if (!hasWebDashboard || !hasDefaultWorkspace) {
      syncCalledRef.current = true;

      syncWebDashboard()
        .then(() => reloadWorkspaces())
        .catch(() => { /* fail silently — non-critical */ });
    }
    else {
      syncCalledRef.current = true;
    }
  }, [authUser?.uuid, userProfile?.plugin_source, isLoadingWorkspaces, workspaces]);

  return (
    <div>
      <Outlet />
    </div>
  );
};

export default TeamDashboard;
